import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import type { IEventType } from '../../../stores/model/metamodel/event_type';

/**
 * Check if the model contains another event type with the same name as the
 * event type under test.
 */
class EventDuplicateCheck extends Check<IEventType> {
  static description = 'Check for duplicate events';

  check(): Report {
    this.report = new Report();
    if (hasDuplicateElementName(this.model.eventTypes, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        'Event with the same name found.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No events with the same name found.',
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default EventDuplicateCheck;
